import React from 'react';
import { Box } from '@mui/material';

export function HoneycombSurfacePhoto({ url, wash, zIndex = -2 }) {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex,
        overflow: 'hidden',
        pointerEvents: 'none',
        isolation: 'isolate',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: '-8%',
          zIndex: 0,
          backgroundImage: `url(${JSON.stringify(url)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(6px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          backgroundColor: wash,
        }}
      />
    </Box>
  );
}
